export const toCapitalizeLetter = (text) => {
    if (text) return text.charAt(0).toUpperCase() + text.slice(1);
    return "";
};

export const reformatCamelText = (text) => {
    let mArr = text.split("_").map((t) => toCapitalizeLetter(t));
    return mArr.join(" ");
};
